// extracted by mini-css-extract-plugin
export default {"wrapper":"sfG8sA7x4D_BTmXUnMKw","avatar":"M75PBkyCpp2LvuM5UrtS"};